import React, { useState, useCallback, useMemo, useEffect } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import ReactDOM from "react-dom";
import cls from './style.module.scss';
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import SizeCountrySelector from "../../../../../components/size-country-selector";
import { BigButton } from "../../../../../../components/button";
import { SET_SEARCH_IMAGE_RESULT } from "../../../../../../../../store/actions/global";
import ProductTransitonModal from "../transition-modal";
import { fetchAddCustomerSize, fetchSearchSizeSimilar, fetchProductExcludeSize } from "../../../../../../../../api";
import { IMAGE_GEEKO_LTD } from "../../../../../../../../constants";
import { setOPLoading } from "../../../../../../../../store/actions/ui";
import { getOriginalSize } from "../../../../../../../utils/sensor";
import { useHistory } from "react-router-dom";
import { getProductUrl } from "../../../../../../../../utils/product";

const SizeSelector = props =>{
    const { setSuccessSize, product, excludeSize, onClose } = props;
    const [sizeGroup, setSizeGroup] = useState(null);
    const [loading, setLoading] = useState(false);
    const global = useSelector(state => state.global);
    const [description, setDescription] = useState(null);
    const history = useHistory();

    useEffect(() =>{
        if(global?.sizeDefaultCountry){
            setSizeGroup(null);

            setDescription(null);
        }
    }, [global?.sizeDefaultCountry]);

    const submitHandle = useCallback(async (sizeData) =>{
        try {
            const { id, sizeChart2 } = product;
            setLoading(true);
            
            let response = await fetchAddCustomerSize({ productId: id, sizeChartId: sizeChart2.id, usSize: sizeData.value });
            if(response?.code === 200){
                setLoading(false);
                setSuccessSize(sizeData);
            }else{
                response?.result && alert(response.result);
            }

            if(window.GeekoSensors){
                window.GeekoSensors.Track('ClickFindSize', {
                    product_id: product?.id,
                    size: getOriginalSize(sizeData.value),
                    button: "submit",
                })
            }
        } catch (error) {
            console.log('error', error)
            setLoading(false);
        }
    }, [product]);

    const handleSelect = useCallback((data) =>{
        setSizeGroup(data)
        setDescription(data.description);
    }, []);

    const getDescription = useCallback(desc => {
        return desc?.replace(/:[\w|\d|\-|(|)|\.]+;/g, function (value) { return '<span style="color:#999;margin-right: 5px;">' + value + ' </span>' })
    }, []);

    const bigOrSmallEvent = useCallback((item, product) =>{
        onClose();
        history.push(getProductUrl(item?.productId, product?.name))
    }, []);

    const excludeSizesData = useMemo(() =>{
        if(!!excludeSize?.countryAndSizesList?.length > 0){
            const { sizeChart2 } = product;

            const countries = sizeChart2.countryAndSizesList?.[0]?.map(c => c.country)

            const sizeDefaultCountry = countries?.find(c => c === global?.sizeDefaultCountry) || sizeChart2?.defaultCountry

            let sizesCountryAndSizesList = excludeSize.countryAndSizesList;

            let excludePlusData = sizesCountryAndSizesList.map(item=>{
                let countryData = item?.sizes.find(data=>data.country === sizeDefaultCountry);
                return { ...countryData, value: item?.sizes[0]?.size, description: item?.description };
            });

            return excludePlusData;
        }
        
        return null;
    }, [product, global?.sizeDefaultCountry, excludeSize]);

    return <div className={`${cls.ModalContainer} ${cls.SizeSelector}`}>
        <div className={cls.Hd}>
            <span className={cls.Title}><FormattedMessage id="tell_us_size" defaultMessage="Tell us your size" /></span>
        </div>

        <div className={cls.Message}>
            <FormattedMessage id="we_optimize_based_feedback" defaultMessage="We will optimize the size range based on your feedback." />
        </div>

        <div className={cls.Bd}>
            <div className={cls.CountrySelector}>
                <SizeCountrySelector className={cls.SizeCountrySelector} sizeChart2={product.sizeChart2} />
            </div>

            <div className={cls.SizeDifferenceContainer}>
                <div className={cls.SizeContainer}>
                    {
                        excludeSize?.associatedSizeProduct?.bigOrSmall === 0 && <a className={`${cls.SizeItem}`} onClick={() =>bigOrSmallEvent(excludeSize.associatedSizeProduct, product)}>
                            <span>{excludeSize.associatedSizeProduct?.title}</span>
                            <Iconfont className={cls.Sword}>&#xe690;</Iconfont>
                        </a>
                    }

                    {
                        excludeSizesData?.map((item, index) =>(
                            <a 
                                key={item.size+index}
                                className={`${cls.SizeItem} ${sizeGroup?.size === item.size ? cls.Active : ''}`} 
                                onClick={()=>handleSelect(item)}
                            >{item.size}</a>
                        ))
                    } 

                    {
                        excludeSize?.associatedSizeProduct?.bigOrSmall === 1 && <a className={`${cls.SizeItem}`} onClick={() =>bigOrSmallEvent(excludeSize.associatedSizeProduct, product)}>
                            <span>{excludeSize.associatedSizeProduct?.title}</span>
                            <Iconfont className={cls.Sword}>&#xe690;</Iconfont>
                        </a>
                    }   
                </div>

                {
                    description && <div className={cls.Description}>
                        <span dangerouslySetInnerHTML={{ __html: getDescription(description) }}></span>
                    </div>
                }
            </div>
        </div>

        <div className={cls.Fd}>
            <BigButton disabled={!sizeGroup} loading={loading} onClick={()=>submitHandle(sizeGroup)}><FormattedMessage id="submit" defaultMessage="Submit" /></BigButton>
        </div>
    </div>
}

const SizeSelectorSuccess = props =>{
    const { onClose, product, successSize } = props;
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const submitHandle = useCallback(async () =>{
        try {
            const { id, sizeChart2 } = product;
            setLoading(true);
            let imageUrl = `${IMAGE_GEEKO_LTD}/large/${product.pcMainImage}`;
            let params = { 
                productId: id, 
                imageUrl: imageUrl, 
                usSize: successSize.value,
                sizeChartId: sizeChart2?.id
            };
            let response = await fetchSearchSizeSimilar(params);
            if(response?.code === 200){
                if(response?.result?.length > 0){
                    await dispatch({
                        type:SET_SEARCH_IMAGE_RESULT,
                        payload:{
                            show:true,
                            url: imageUrl,
                            searchType: 1,
                            result: response.result,
                            sensors: {
                                resourcepage_title: "virtual-search",
                                resource_position: "2",
                                resource_type: "19",
                                resource_content: getOriginalSize(successSize.value)
                            }
                        }
                    });
                }else{
                    await dispatch({
                        type:SET_SEARCH_IMAGE_RESULT,
                        payload:{
                            show:true,
                            url: imageUrl,
                            searchType: 1,
                            productId: id,
                            sensors: {
                                resourcepage_title: "virtual-search",
                                resource_position: "2",
                                resource_type: "19",
                                resource_content: getOriginalSize(successSize.value)
                            }
                        }
                    });
                }

                onClose();
            }else{
                response?.result && alert(response.result);
            }

            setLoading(false);
            if(window.GeekoSensors){
                window.GeekoSensors.Track('ClickFindSize', {
                    product_id: id,
                    size: getOriginalSize(successSize.value),
                    button: "find similar",
                })
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }, [product, successSize]);

    return <div className={`${cls.ModalContainer} ${cls.SizeSelectorSuccess}`}>
        <div className={cls.SucIcon}>
            <Iconfont>&#xe6b7;</Iconfont>
        </div>

        <p className={cls.Message1}><FormattedMessage id="thanks_your_feedback" defaultMessage="Thanks for your feedback." /></p>

        <p className={cls.Message2}><FormattedMessage id="submit_successful" defaultMessage="Submit Successful" />!</p>
        
        {
            !successSize?.isNotFind && <React.Fragment>
                <p className={cls.Message3}><FormattedMessage id="we_found_similar_size" defaultMessage="We also found similar items for you in size" /> {successSize?.size}</p>
                
                <div className={cls.SubmitBtn}>
                    <BigButton onClick={submitHandle} loading={loading}><FormattedMessage id="find_simillar" defaultMessage="Find similar" /></BigButton>
                </div>
            </React.Fragment>
        }
    </div>
}

const SizeSelectorWrapprd = props =>{
    const [successSize, setSuccessSize] = useState(null);

    return <React.Fragment>
        <div style={{ display: `${!successSize?'block':'none'}` }}>
            <SizeSelector {...props} setSuccessSize={setSuccessSize} />
        </div>

        <div style={{ display: `${successSize?'block':'none'}` }}>
            <SizeSelectorSuccess {...props} successSize={successSize} />
        </div>
    </React.Fragment>
}

const SizeSelectorAlert = props => {
    useStyles(cls)

    if (typeof window === 'undefined') return null

    return ReactDOM.createPortal(
        <React.Fragment>
            <ProductTransitonModal show={props.show} onClose={props.onClose} className={cls.SizeSelectorContainer}>
                <SizeSelectorWrapprd {...props} />
            </ProductTransitonModal>
        </React.Fragment>,
        document.getElementById('root')
    )
}

export default props =>{
    useStyles(cls);
    const { productId } = props;
    const [show, setShow] = useState(false);
    const [excludeSize, setExcludeSize] = useState(null);
    const dispatch = useDispatch();

    const handleClick = useCallback(async (id) =>{
        if(window.GeekoSensors){
			window.GeekoSensors.Track('ClickFindSize', {
				product_id: id,
			})
		}

        dispatch(setOPLoading(true));
        let response = await fetchProductExcludeSize(id);
        if(response?.code === 200 && response?.result){
            setShow(true);
            setExcludeSize(response.result);
        }else{
            setExcludeSize(null);
            response?.result && alert(response.result);
        }
        dispatch(setOPLoading(false));
    }, []);

    return <React.Fragment>
        <div className={cls.ForHelpTip} onClick={()=>handleClick(productId)}>
            <FormattedMessage id="can_find_your_size" defaultMessage="Can't find your size?" /> <span style={{ color: '#2763A5' }}><FormattedMessage id="tell_us_size" defaultMessage="Tell us your size" /></span>
        </div>

        <SizeSelectorAlert 
            show={show} 
            onClose={()=>setShow(false)} 
            excludeSize={excludeSize} 
            {...props}
        />
    </React.Fragment>
}